import type { CSSProperties } from 'react';

import { Button } from './Button';

/** Werkzeugleiste der `SimpleTable` — Pendant zu `Toolbar="Add|Delete|Search"`. */
export interface SimpleTableToolbarProps {
  showSearch: boolean;
  showAdd: boolean;
  showDelete: boolean;
  search: string;
  onSearchChange: (text: string) => void;
  onAdd?: () => void;
  onDelete?: () => void;
}

// Für .e-toolbar existieren keine übernommenen Regeln; die Anordnung steht
// deshalb inline, damit keine unbelegte Klasse erfunden wird.
//
// Der waagerechte Innenabstand ist derselbe wie in Kopfzeile und Zeilen der
// Tabelle ($grid-cell-padding-x in ui/_tokens.scss). Ohne ihn standen
// „Add"/„Delete" und das Suchfeld bündig am Kartenrand, während die Spalten
// darunter 14px einrückten (REQ-23 §4.1).
const BAR: CSSProperties = {
  alignItems: 'center',
  display: 'flex',
  gap: '0.5rem',
  padding: '0.5rem 14px',
};
const SEARCH: CSSProperties = { marginLeft: 'auto', width: 220 };

export function SimpleTableToolbar(props: SimpleTableToolbarProps) {
  return (
    <div className="e-toolbar" style={BAR}>
      {props.showAdd ? (
        <Button content="Add" iconClass="e-icons e-plus" onClick={props.onAdd} />
      ) : null}
      {props.showDelete ? (
        <Button content="Delete" iconClass="e-icons e-delete" onClick={props.onDelete} />
      ) : null}
      {props.showSearch ? (
        <span className="e-input-group" style={SEARCH}>
          <input
            type="search"
            className="e-input"
            placeholder="Search"
            aria-label="Search"
            value={props.search}
            onChange={(event) => {
              props.onSearchChange(event.target.value);
            }}
          />
          <span className="e-input-group-icon e-search-icon e-icons fa-solid fa-magnifying-glass" />
        </span>
      ) : null}
    </div>
  );
}

export default SimpleTableToolbar;
